// import PropTypes from 'prop-types';
import React from 'react';
import { EventLandingPage } from '../../../components/Events/EventLandingPage/EventLandingPage';
import Layout from '../../../components/Layout/LayoutV2/Layout';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

const SingleEvent = (props) => {
    const { event, attendeeCount, upcomingEvents } = props;

    return (
        <div className="single-event-page">
            <SnowplowPageViewTracker
                pageSection={PAGE_VIEW_SECTIONS.EVENTS}
                pageType={PAGE_VIEW_TYPES.CONTENT}
                pageEntityId={event.hash}
            />
            <Layout {...props}>
                <EventLandingPage
                    event={event}
                    attendeeCount={attendeeCount}
                    upcomingEvents={upcomingEvents}
                />
            </Layout>
        </div>
    );
};

export default SingleEvent;
